import BreadCrumbs from '@/_application/core/components/ui/breadcrumbs/breadcrumbs';
import BreadCrumbSeoSchema from '@/_application/core/components/seo/bread-crumb-seo-schema';
import {Breadcrumb} from '__generated__/__types__';
import {getProductUrl, Product} from '@/_application/modules/products/model/product';
import {convertDataToBreadCrumbs} from '@/_application/modules/categories/models/bread-crumbs';
import {getBreadCrumsByProduct} from '../../helpers/product-bread-crumbs';

interface IProps {
    product: Product;
}

const ProductBreadCrumbs = ({product}: Readonly<IProps>) => {
    if (!product?.id || !product?.breadcrumbs?.length) {
        return <></>;
    }

    const breadcrumbs = getBreadCrumsByProduct(product);

    if (!breadcrumbs?.breadcrumbs) {
        return <></>;
    }

    return <BreadCrumbs items={breadcrumbs?.breadcrumbs} />;
};
export default ProductBreadCrumbs;
